import { render, staticRenderFns } from "./FacilityStatusTab.vue?vue&type=template&id=35c5412c&scoped=true&lang=pug"
import script from "./FacilityStatusTab.vue?vue&type=script&lang=ts"
export * from "./FacilityStatusTab.vue?vue&type=script&lang=ts"
import style0 from "./FacilityStatusTab.vue?vue&type=style&index=0&id=35c5412c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c5412c",
  null
  
)

export default component.exports